var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Layout d-flex flex-column j-start a-center"},[_c('nav-bar'),_c('div',{staticClass:"view"},[_c('transition',{attrs:{"name":"fade-in"}},[_c('router-view')],1),_c('bottom')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }